export const authenticationConstants = {
    AUTHENTICATION_FAILED: "auth_failed",
    AUTHENTICATION_SUCCESSFUL: "auth_successful",
    AUTHENTICATION_LOGOUT: "auth_logout",
}